export default __webpack_public_path__ + "static/ak-cached/24h/media/vms1100.cdb1ede2.png";